// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xbim","fullView":"styles_fullView__2MSiZ"};